/* ==========================================================================
   Button > Client > Prototype
   ========================================================================== */

const button = {
    /* Get Content El */
    getContentEl() {
        return this.element.querySelector('[data-content]');
    },
    /* Get Icon El */
    getIconEl() {
        return this.element.querySelector('i');
    },
    /* Get Content */
    getContent() {
        return this.getContentEl().innerText;
    },
    /* Set Content */
    setContent(content = '') {
        this.getContentEl().innerText = content;

        return this;
    },
    /* Get value */
    getValue() {
        return this.element.value;
    },
    /* Set value */
    setValue(value = '') {
        this.element.value = value;

        return this;
    },
    /* Set Icon */
    setIcon(icon = '') {
        this.getIconEl().classList.add(icon);

        return this;
    },
    /* Remove Icon */
    removeIcon(icon = '') {
        this.getIconEl().classList.remove(icon);

        return this;
    },
    /* Replace icon */
    replaceIcon(newIcon = '', oldIcon = '') {
        this.removeIcon(oldIcon);
        this.setIcon(newIcon);

        return this;
    },
    /* Display */
    show() {
        if (!this.hidden) return this;

        this.element.classList.remove(this.config.css.hidden);
        this.hidden = false;

        return this;
    },

    /* Hide */
    hide() {
        if (this.hidden) return this;

        this.element.classList.add(this.config.css.hidden);
        this.hidden = true;

        return this;
    },

    /* Disable */
    disable() {
        if (this.disabled) return this;

        this.element.classList.add(this.config.css.disable);
        this.element.disabled = true;
        this.disabled = true;

        return this;
    },

    /* Enable */
    enable() {
        if (!this.disabled) return this;

        this.element.classList.remove(this.config.css.disable);
        this.element.disabled = false;
        this.disabled = false;

        return this;
    },

    /* Set active */
    setActive() {
        this.element.classList.add(this.config.css.active);

        return this;
    },

    /* Remove Active */
    removeActive() {
        this.element.classList.remove(this.config.css.active);

        return this;
    },

    /* Destroy */
    destroy() {
        this.element.parentNode.removeChild(this.element);
    },

    /* On change */
    onClick(event) {
        /* Fire external callbacks */
        if (this.config.onClick.length > 0) this.config.onClick.forEach(item => item.call(this, this));

        /* Prevent bubbling */
        event.stopPropagation();

        return this;
    },

    /* Add event listener */
    addEventListener() {
        /* Bind events */
        this.bindEvents();

        /* On click */
        this.element.addEventListener('click', this.onClick);

        return this;
    },

    /* Remove event listener */
    removeEventListener() {
        /* On click */
        this.element.removeEventListener('click', this.onClick);

        return this;
    },

    /* Bind events */
    bindEvents() {
        this.onClick = this.onClick.bind(this);

        return this;
    },

    /* Init */
    init() {
        /* Adding listener */
        if (this.config.domEvents) this.addEventListener();
    }
};

module.exports = button;
